import { render, staticRenderFns } from "./PersonTypePicker.vue?vue&type=template&id=b8f93050&scoped=true&"
import script from "./PersonTypePicker.vue?vue&type=script&lang=ts&"
export * from "./PersonTypePicker.vue?vue&type=script&lang=ts&"
import style0 from "./PersonTypePicker.vue?vue&type=style&index=0&id=b8f93050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f93050",
  null
  
)

export default component.exports